import { Link } from "react-router-dom";

export const BrandMark = ({ onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid="brand-logo"
    className="flex items-center transition-transform duration-300 hover:-translate-y-0.5"
  >
    <img src="/walkoff-logo.png" alt="Walk-Off Digital" className="h-12 w-auto sm:h-[52px]" />
  </Link>
);
